import * as React from 'react';
import { Mutation, MutationFn } from 'react-apollo';

import GET_COACH_AVAILABILITIES_AND_TIMEZONE_QUERY from 'coaching/queries/GetCoachAvailabilityAndCoachTimezone.gql';
import SET_COACHING_AVAILABILITY_MUTATION from 'coaching/mutations/SetCoachingAvailability.gql';
import {
  SetCoachingAvailability,
  SetCoachingAvailabilityVariables,
} from 'coaching/mutations/__generated__/SetCoachingAvailability';
import ToastActions from 'actions/ToastActions';

export type Props = {
  coachUuid: string;
  startDateTime: string;
  endDateTime: string;
  children: (props: {
    setCoachingAvailability: MutationFn<SetCoachingAvailability, SetCoachingAvailabilityVariables>;
  }) => React.ReactNode;
};

export default function SetCoachAvailabilitiesContainer(props: Props) {
  return (
    <Mutation<SetCoachingAvailability, SetCoachingAvailabilityVariables>
      mutation={SET_COACHING_AVAILABILITY_MUTATION}
      onCompleted={() => ToastActions.showSuccessToast('Saved your normal availability')}
      onError={error => ToastActions.showErrorToast(error.message)}
      refetchQueries={[
        {
          query: GET_COACH_AVAILABILITIES_AND_TIMEZONE_QUERY,
          variables: {
            coachUuid: props.coachUuid,
            startDateTime: props.startDateTime,
            endDateTime: props.endDateTime,
          },
        },
      ]}>
      {setCoachingAvailability => {
        return props.children({ setCoachingAvailability });
      }}
    </Mutation>
  );
}
